<div class="alert">
    <div class="text-center">
        @if (icon !== "") {
            <kui-icon class="mb-3 muted-more d-block" [name]="icon || 'exclamation'" [size]="size"></kui-icon>
        }
        @if (message) {
            <div class="mb-3">{{ message }}</div>
        }

        @if (actionText) {
            <button kui-button color="primary" (click)="onAction.emit()">
                {{ actionText | translate }}
            </button>
        }
        <ng-content></ng-content>
    </div>
</div>
